// extracted by mini-css-extract-plugin
module.exports = {"bottomSpacing":"BenefitPage_bottomSpacing__1yZbM","stepperButtons":"BenefitPage_stepperButtons__3VYDp","modalMessageContent":"BenefitPage_modalMessageContent__2RYen"};